import React from 'react';

// The owner's mark, identical to /assets/imgaff-mark.svg on imgaff.com and to
// the operations console: a blue frame, the lens, and the three feed chips.
// The wordmark stays HTML text so it inherits var(--display) and the ink colour.
const BrandLogo: React.FC<{ compact?: boolean }> = ({ compact = false }) => (
  <span className={`brand-logo${compact ? ' compact' : ''}`} aria-label="ImgAff">
    <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <rect x="3.2" y="4.2" width="41.6" height="39.6" rx="4.2" fill="none" stroke="#0178FE" strokeWidth="2.4" />
      <circle cx="14.8" cy="15.3" r="5.2" fill="#0178FE" />
      <rect x="21.3" y="33.9" width="6.1" height="6.8" rx="1.4" fill="#C1C1C4" />
      <rect x="28.7" y="33.9" width="5.8" height="6.8" rx="1.4" fill="#76CE29" />
      <rect x="35.7" y="33.9" width="5.7" height="6.8" rx="1.4" fill="#FF8904" />
    </svg>
    {!compact && <span>ImgAff</span>}
  </span>
);

export default BrandLogo;
